<div>
  <h6 class="odx-title-6" i18n="@@global.freeText">Freitext</h6>

  <app-floorplan-menu-item-buttons>
    <app-add-button
      (add)="addFreeText()"
      [odxTooltip]="tooltipTextAddFreeText"
      [odxTooltipOptions]="{ position: 'bottom' }"
      (dragStart)="dragFreeText()"
    ></app-add-button>
    <app-toggle-visibility-button
      [visible]="floorplanState.floorplanFreeTextsVisible"
      (toggleEvent)="floorplanState.floorplanFreeTextsVisible = $event"
    ></app-toggle-visibility-button>
    <app-toggle-item-text-visibility-button
      [itemTextVisible]="floorplanState.floorplanFreeTextsItemTextVisible"
      (toggleEvent)="updateFreeTextsItemTextVisibility($event)"
    ></app-toggle-item-text-visibility-button>
    <app-toggle-lock-button
      [locked]="floorplanState.floorplanFreeTextsLocked"
      (toggleEvent)="floorplanState.floorplanFreeTextsLocked = $event"
    ></app-toggle-lock-button>
  </app-floorplan-menu-item-buttons>
</div>
